import { useEffect, useRef } from 'react';

export const useIdleTimer = (onIdle, timeout = 15 * 60 * 1000) => {
  const timerRef = useRef(null);

  useEffect(() => {
    // Function to reset the timer whenever user activity is detected
    const resetTimer = () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        onIdle(); // Trigger the logout function passed as a prop
      }, timeout);
    };

    // List of events that constitute "user activity"
    const events = [
      'mousedown',
      'mousemove',
      'keypress',
      'scroll',
      'touchstart'
    ];

    // Add event listeners to the window
    events.forEach(event => window.addEventListener(event, resetTimer));

    // Initialize the timer on mount
    resetTimer();

    // Cleanup event listeners and timers when the component unmounts
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      events.forEach(event => window.removeEventListener(event, resetTimer));
    };
  }, [onIdle, timeout]);
};